export default "__VITE_PUBLIC_ASSET__752f231d__"